import { FailureModalForUploadDocComponent } from '../../../../screens/failure-modal-for-upload-doc/failure-modal-for-upload-doc.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { InProgressModalComponent } from '../../../../screens/in-progress-modal/in-progress-modal.component';
import { SuccessModalForUploadDocComponent } from '../../../../screens/success-modal-for-upload-doc/success-modal-for-upload-doc.component';
import { InvalidFileTypeModalComponent } from '../../../../screens/invalid-file-type-modal/invalid-file-type-modal.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule , TitleCasePipe } from '@angular/common';
import { Location } from '@angular/common';
import { Component, HostListener, OnInit , NO_ERRORS_SCHEMA } from '@angular/core';
import { FormControl, FormGroup, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { UserDataService } from '@services/data-services/user-data.service';
import { FooterPositionService } from '@services/footer-position-service/footer-position.service';
import { PolicyDetailsService } from '@services/my-insurance/policy-details.service';
import { PolicyBillingUploadService } from '@services/policy-billing-upload.service';
import { forkJoin, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, InvalidFileTypeModalComponent, SuccessModalForUploadDocComponent, InProgressModalComponent, MapfreModalComponent, FailureModalForUploadDocComponent],
  selector: 'app-upload-policy-billing-document',
  templateUrl: './upload-policy-billing-document.component.html',
  styleUrls: ['./upload-policy-billing-document.component.scss'],
  providers: [TitleCasePipe]
})
export class UploadPolicyBillingDocumentComponent implements OnInit {
  // moreThan8MBfileObservablesList = [];
  // lessThan8MBfileObservablesList = [];
  fileObservablesList = [];
  statusObservablesList = [];
  uploadDocForm: FormGroup;
  policies: any;
  policyMap: any[];
  user: any;
  files: any;
  loading: boolean;
  invalidFileType: string;
  documentType: any;
  documentTypes: any;
  editIconPath: string;
  deleteIconPath: string;
  showSuccessModal: boolean;
  showFailureModal: boolean;
  showInProgressModal: boolean;
  policyNumber: string;
  failureModalOptions: ModalOptions;
  hideModal: boolean;
  documentFileNames: any;
  policy: any;
  isAcmic: boolean;
  constructor(
    private policyDataService: PolicyDataService,
    private location: Location,
    private acmicService: AcmicService,
    private router: Router,
    private pbUploadService: PolicyBillingUploadService,
    private titleCasePipe: TitleCasePipe, private userDataService: UserDataService,
    private policyDetailsService: PolicyDetailsService,
    private footerPositon:FooterPositionService,
    private navService: NavigationService
  ) {
    this.loading = false;
    this.hideModal = true;
    this.files = [];
    this.documentTypes = [];
    this.documentFileNames = [];
    this.showSuccessModal = false;
    this.showFailureModal = false;
    this.showInProgressModal = false;
    this.isAcmic = this.acmicService.isACMIC();
  }
  goBack() {
    this.location.back();
  }

  createNewFormControlls() {
    for (let i = 0; i < this.files.length; i++) {
      this.uploadDocForm.addControl(`documentType${i}`, new FormControl(null, [Validators.required]));
      this.uploadDocForm.addControl(`documentName${i}`, new FormControl(null, [Validators.required]));
      if (this.files[i].documentType) {
        this.uploadDocForm.controls[`documentType${i}`].setValue(this.files[i].documentType);
      }
      if (this.files[i].documentName) {
        this.uploadDocForm.controls[`documentName${i}`].setValue(this.files[i].documentName);
      } else {
        this.uploadDocForm.controls[`documentName${i}`].setValue(this.files[i].file.name);
      }
    }
  }

  removeControlls() {
    for (let i = 0; i < this.files.length; i++) {
      this.uploadDocForm.removeControl(`documentType${i}`);
      this.uploadDocForm.removeControl(`documentName${i}`)
    }
  }
  deleteDocumentFields(index) {
    this.removeControlls();
    this.files.splice(index, 1);
    setTimeout(() => {
      this.createNewFormControlls();
    }, 200);
  }
  toggleEditAndSave(flag, index, type?) {
    this.files[index].saved = flag;
    if (type === 'save') {
      const fileName = this.uploadDocForm?.controls[`documentName${index}`]?.value;
      this.files[index].isEdit = true;
      this.files[index].file = new File([this.files[index].file], fileName, { type: this.files[index].file.type });
      this.files[index].documentName = fileName;
      this.files[index].documentType = this.uploadDocForm?.controls[`documentType${index}`]?.value;
    } else {
      this.files[index].isEdit = false;
    }

  }

  saveFiles(files: FileList) {
    for (let i = 0; i < files.length; i++) {
      if (this.isValidFileType(files[i]) && this.files?.length < 10) {
        const controlIndex = this.files.length;
        this.files.push({ file: files[i], saved: false, documentType: '' });
        this.uploadDocForm.addControl(`documentType${controlIndex}`, new FormControl(null, [Validators.required]));
        this.uploadDocForm.addControl(`documentName${controlIndex}`, new FormControl('', [Validators.required]));
        this.uploadDocForm.controls[`documentName${controlIndex}`].setValue(files[i].name);
      }
    }

  }
  listOfFiles() {
    return this.files.filter(file => file?.isEdit);
  }
  @HostListener("dragover", ["$event"]) onDragOver(event: any) {
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      const files: FileList = event.dataTransfer.files;
      this.saveFiles(files);
    }
  }
  isValidFileType(file) {
    this.invalidFileType = '';
    const allowedFileFormats = ['jpeg', 'jpg', 'pdf', 'gif', 'png'];
    if (file.size > 50000 * 1024) {
      this.invalidFileType = 'too_big';
      return false;
    }
    const type = file.type.split('/');
    if (!allowedFileFormats.includes(type[1])) {
      this.invalidFileType = 'invalid_format';
      return false;
    }
    return true;
  }
  onChange(event) {
    this.saveFiles(event?.target?.files);
  }
  onDoumentSelect(index, event) {
    const documentType = event?.type;
    this.files[index].documentName = this.uploadDocForm?.controls[`documentName${index}`]?.value;
    this.uploadDocForm.controls[`documentType${index}`].setValue(documentType);
    this.files[index].documentType = documentType;
    this.files[index].selectedDocObj = this.documentTypes.find(docTypeObj => docTypeObj?.type === documentType);
    this.toggleEditAndSave(true, index);
  }
  constructSendEmailPayload() {
    return {
      "firstName": this.user?.userDetails?.firstName,
      "policyType": this.policy?.displayType?.label?.toUpperCase() ?? this.policy?.policyType,
      "policyNumber": this.policy?.policynumber?.policyNumber,
      "emailId": this.user?.userDetails?.email?.address,
      "documentList": this.documentFileNames
    }
  }
  sendUploadEmailToUser(payload) {
    this.pbUploadService.sendDocumentUploadEmail(payload).subscribe(res => {
      console.log(res);
    }, err => {
      console.log(err);
    })
  }
  isEligibleToShowFailureModal(result) {
    return result.filter(r => (r !== true) && r.error).length === result.length;
    // return result.every(r => !r.success);
  }
  uploadFileSequence(file: any, index, base64String, fileExtension) {
    let  isLegacy, sourceSystem;
    if (this.policyNumber.length === 10) {
      sourceSystem = 'GW';
      isLegacy = false;
    } else {
      sourceSystem = 'AS400';
      isLegacy = true;
    }

    return this.policyDetailsService.getPreSignedDocumentsForUpload(sourceSystem, this.policyNumber, this.files[index]?.selectedDocObj?.relatedTo, file?.documentName, isLegacy, this.files[index]?.selectedDocObj?.type, this.files[index]?.selectedDocObj?.ecmDocCode,this.policyNumber).pipe(
      mergeMap((response: any) => {
        response.SignedDocumentumData.StreamObj = {
          StreamedDocument: base64String.split(',')[1],
          StreamSize: JSON.stringify(file?.file?.size),
          FileExt: fileExtension
        }
        //this.policyDetailsService.getUploadFileStatus(response?.PresignedDocumentResponse?.transactionId)
        this.statusObservablesList.push(this.policyDetailsService.getUploadFileStatus(response?.PresignedDocumentResponse?.transactionId,this.policyNumber).pipe(
          catchError((error) => { 
            console.log('error in getUploadFileStatus', error);
            return of(false); 
          })))
        return this.policyDetailsService.sendPresignedUploadDocument(response?.PresignedDocumentResponse?.signedUrl, response.SignedDocumentumData)
      }
      ), catchError(() => of(false)
      ))
  }
  async uploadDocuments() {
    this.navService.saveCurrentAction(ActionType.AddDocuments);
    this.loading = true;
    this.documentFileNames = [];
    let base64String;
    let fileExtension: string;
    let file;
    // this.lessThan8MBfileObservablesList = [];
    // this.moreThan8MBfileObservablesList = [];
    this.fileObservablesList = [];
    this.statusObservablesList = [];
    for (let index = 0; index < this.files.length; index++) {
      file = this.files[index];
      if (file) {
        try {
          base64String = await this.readFileAsync(file);
          const fileNameParts: string[] = file?.file?.name.split('.');
          fileExtension = fileNameParts[fileNameParts.length - 1];
          this.documentFileNames.push({ fileName: file?.documentName });
          this.fileObservablesList.push(this.uploadFileSequence(file, index, base64String, fileExtension));
          // if (file?.file?.size > 8000 * 1024) {
          //   this.moreThan8MBfileObservablesList.push(this.uploadFileSequence(file, index, base64String, fileExtension));
          // } else {
          //   const formData: FormData = new FormData();
          //   formData.append('file', file?.file);
          //   this.lessThan8MBfileObservablesList.push(this.pbUploadService
          //     .uploadDocuments(
          //       this.files[index]?.selectedDocObj?.type,
          //       formData,
          //       this.policyNumber,
          //       this.files[index]?.selectedDocObj?.relatedTo,
          //       this.files[index]?.selectedDocObj?.ecmDocCode
          //     )
          //     .pipe(catchError((error) => of(false)))
          //   )
          // }

        } catch {
          //do nothing
        }
      };

    };
    this.invokeUploadApi();
    // if(this.moreThan8MBfileObservablesList?.length ) {
    //   this.invokeUploadApi();
    // } else {
    //   this.getUploadStatus(false);
    // }
    
  }
  readFileAsync(file): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file?.file);
    });
  }
  areAllFailed(result) {
    return !result.some(r => r || r === null);
  }
  atleastOneFailed(result) {
    return result.some(r => r === false); 
  }
  atleastOneError(result) {
    return result.some(r => r === 'ERROR'); 
  }
  atleastOneInprogress(result) {
    return result.some(r => r === 'IN-PROCESS'); 
  }
  invokeUploadApi() {
    forkJoin(this.fileObservablesList).subscribe(
      (res: any) => {
        // const allMorethan8MBFailed = this.areAllFailed(res);
        const atLeaseOneUploadFailed = this.atleastOneFailed(res); 
        if(atLeaseOneUploadFailed) {
          this.showFailureModal = true;
          this.loading = false;
        } else {
          this.getUploadStatus();
        }
      },
      () => {
        this.showFailureModal = true;
        this.loading = false;
      }
    );
  }
  getUploadStatus() {
    forkJoin([...this.statusObservablesList]).subscribe(
      (combineStatusResults) => {
        // const combineStatusResults = [...statusResults, ...lessThan8StatusResults];
        this.loading = false;
        if(combineStatusResults && this.atleastOneError(combineStatusResults)) {
          this.showFailureModal = true;
        } else if(combineStatusResults && this.atleastOneInprogress(combineStatusResults)) {
          this.showInProgressModal = true;
        } else {
          const payload = this.constructSendEmailPayload();
          this.sendUploadEmailToUser(payload);
          this.removeControlls();
          this.files = [];
          this.showSuccessModal = true;
        }
      }, () => {
        this.showFailureModal = true;
        this.loading = false;
      }
    )
  }
  getAllowedPolicies(policyList) {
    return policyList.filter(policy => {
      const policyType = `${policy?.policyType || ''}`.toUpperCase();
      return policyType.includes('AUTO') || policyType.includes('HOME') || policyType.includes('UMBRELLA');
    });
  }
  makeItDissableForSinglePolicy() {
    this.documentTypes = this.pbUploadService.getPolicySelectList(this.policies[0]);
    this.policyMap[0].disabled = true;
    this.uploadDocForm.controls.selectedPolicy.setValue(this.policyMap[0].name);
    this.uploadDocForm.controls.selectedPolicy.disable();
  }
  getPolicies() {
    this.policyDataService.$policyDetails.subscribe((policyList) => {
      if (policyList) {
 // Filter only 10-digit policy numbers
      this.policies = this.getAllowedPolicies(policyList).filter(policy =>
        /^\d{10}$/.test(policy?.policynumber?.policyNumber?.toString() || '')
      );        this.policyMap = this.policies.map(p => {
          const modifiedPolicyName = p.displayType?.label ?? p.policyType;
          return { ...p, disabled: false, name: `${modifiedPolicyName} - ${p.policynumber.policyNumber}` }
        });
        if (this.policies?.length === 1) {
          this.policyNumber = this.policies[0]?.policynumber?.policyNumber;
          this.makeItDissableForSinglePolicy();
        } else if (this.policy) {
          this.documentTypes = this.pbUploadService.getPolicySelectList(this.policy);
          const modifiedPolicyName = this.policy?.displayType?.label ?? this.policy.policyType;
          this.policyMap = [{ ...this.policy, disabled: true, name: `${modifiedPolicyName} - ${this.policy.policynumber.policyNumber}` }];
          this.uploadDocForm.controls.selectedPolicy.setValue(this.policyMap[0].name);
          this.uploadDocForm.controls.selectedPolicy.disable();
        }
      }
    });
  }
  onPOlicySelect() {
    const policyTypeId = this.uploadDocForm.get('selectedPolicy').value || '';
    const selectedPolicyValue = `${policyTypeId}`;
    const policyNumber = selectedPolicyValue.includes(' - ')
      ? selectedPolicyValue.split(' - ').pop()
      : selectedPolicyValue.trim().split(/\s+/).pop();
    this.policyNumber = policyNumber || '';
    this.policy = this.policies.find((policy) => policy?.policynumber?.policyNumber === this.policyNumber);
    if (this.policy) {
      this.documentTypes = this.pbUploadService.getPolicySelectList(this.policy);
    }
  }
  setImagePath() {
    if (this.acmicService.isACMIC()) {
      this.editIconPath = 'assets/img/images/icon-edit-blue-24.svg';
      this.deleteIconPath = 'assets/img/images/icon-delete-acmic-blue.svg';
    } else {
      this.editIconPath = 'assets/img/images/icon-edit.svg';
      this.deleteIconPath = 'assets/img/images/icon-delete.svg';
    }
  }
  tryAgain(event: boolean) {
    this.showFailureModal = false;
    if (!event) {
      this.router.navigate(['my-insurance', this.policyNumber, 'documents']);
    }
  }

  hideOnClick(event): void {
    if (!event.target.closest(".modal-body")) {
      this.resetHideModal();
    }
  }
  resetHideModal() {
    this.hideModal = !this.hideModal;
    this.showFailureModal = false;
  }
  setModalOptions() {
    this.failureModalOptions = new ModalOptions({
      additionalClasses:
        'modal-lg modal-dialog center-on-page confirm-modal email-update edit-contact-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'uploadsFailureSubmitModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      size: 'modal-lg',
      modalName: 'uploads_failure_submit_modal',
    });
  }
  getUserData() {
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        this.user = user;
      }
    });
  }
  setDefaultForm() {
    this.uploadDocForm = new FormGroup({
      selectedPolicy: new FormControl(null)
    });
  }
  setStatePolicyData() {
    this.policy = history?.state?.policyData;
    this.policyNumber = this.policy?.policynumber?.policyNumber;
  }
  closeShowSuccessModal() {
    this.showSuccessModal = false;
  }
  closeShowInProgressModal() {
    this.showInProgressModal = false;
  }

  closeInvalidFileTypeModal() {
    this.invalidFileType = "";
  }
  onDropdownClose(){
    this.footerPositon.updateDropdownState(false);
  }
  onDropdownOpen(){
    this.footerPositon.updateDropdownState(true);
  }
  ngOnInit(): void {
    this.setStatePolicyData();
    this.setDefaultForm();
    this.getUserData();
    this.setModalOptions();
    this.setImagePath();
    this.getPolicies();
    this.isAcmic = this.acmicService.isACMIC();
  }

}
